import axios from 'axios';
import qs from 'qs';

class _Morty {
    
    constructor() {
		this.token = window.pageVariables.morty_token;
		this.pageTitle = null;
		this.pageCrumb = null;
    }
    
    get(url, params) {
		let _params = { 'morty_token': this.token };
		if(params) {
			_params = Object.assign({}, _params, {
				..._params,
				...params
			});
		}
		url += '?' + qs.stringify(_params);
		return axios.get(url).then((data) => data.data );
    }

    post(url, params) {
		let _params = { 'morty_token': this.token };
		if(params) {
			_params = Object.assign({}, _params, {
				..._params,
				...params
			});
		}
		let postData = qs.stringify(_params);

		return axios({
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			data: postData,
			url: url }).then((data) => data.data);
    }

    hasPermission(type) {
		if(window.pageVariables.manager)
			return true;
		return window.pageVariables.permissions.indexOf(type) !== -1;
    }

    renderTitle() {
		let s = "padding-left: 10px; font-size: 14pt; color: #393939";

		if(document.getElementById('admin-base-header')) {
			let c = (this.pageCrumb ? "<span style=\"" + s + "\">" + this.pageCrumb + "</span>" : '');	    
			document.getElementById('admin-base-header').innerHTML = this.pageTitle + c;
		}
		if(document.getElementsByTagName('title')) {
			document.getElementsByTagName('title')[0].innerText = ((this.pageCrumb ? this.pageCrumb + " | " : '') + 
																   (this.pageTitle ?
																	this.pageTitle :
																	"Fancy Hands")); 

		}
		
    }
    
    setTitle(title) {
		this.pageTitle = title;
		this.renderTitle();
    }
    setCrumb(crumb) {
		this.pageCrumb = crumb;
		this.renderTitle();
    }    

    setSubTitle(subtitle) {
		if(document.getElementById('admin-base-subtitle')) {
			document.getElementById('admin-base-subtitle').innerHTML = subtitle;
		}
    }
    
    localMessage(type, payload) {
		return {
			envelope: {
			},
			meta: {
				date: new Date(),
				type: type
			},
			payload: payload
		};
    }
    
};


let Morty = new _Morty();
export default Morty;

